import { render, staticRenderFns } from "./app.coming.soon.vue?vue&type=template&id=67f75f82&scoped=true&"
import script from "./app.coming.soon.vue?vue&type=script&lang=js&"
export * from "./app.coming.soon.vue?vue&type=script&lang=js&"
import style0 from "./app.coming.soon.vue?vue&type=style&index=0&id=67f75f82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../common/temp/node_modules/.pnpm/vue-loader@15.10.0_68125b3067bc9264b7f5e63a32c23d52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f75f82",
  null
  
)

export default component.exports